import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { useFirebaseAuth } from '../contexts/FirebaseAuthContext';
import { firebaseApp, isFirebaseConfigured } from '../firebase/config';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useFirebaseAuth();
  const laravelToken = localStorage.getItem('token');

  if (laravelToken) {
    return children;
  }

  if (isFirebaseConfigured() && firebaseApp) {
    const auth = getAuth(firebaseApp);
    const effectiveUser = user || auth.currentUser;

    if (loading && !effectiveUser) {
      return null;
    }
    if (!effectiveUser) {
      return <Navigate to="/admin/login" replace />;
    }
    return children;
  }

  return <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;
